import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { checkParams } from "../../../src/util/Util";
import "./ForgotPassword.css";

const ForgotPassword = (props) => {
  const [email, setEmail] = useState("");
  const [errorEmail, setErrorEmail] = useState("");
  const [successLoad, setSuccessLoad] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    props.actSidebar(false);
    props.checkLoggedIn(false);
  }, [props]);

  const submitMailToForgot = (e) => {
    e.preventDefault();
    if (!checkParams(email, "email")) {
      setErrorEmail("Invalid email address!");
    } else {
      setErrorEmail("");
      axios
        .post(window.ajaxLink + "user/forgotpassword", { email })
        .then((res) => {
          if (res.data.responseData) {
            setSuccessLoad(true);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 417) {
            setErrorEmail(error.response.data.errorData);
          }
        });
    }
  };

  useEffect(() => {
    function handleEscapeKey(event) {
      event.stopPropagation();
      if (event.code === "Escape") {
        setSuccessLoad(false);
      }
    }

    document.addEventListener("keydown", handleEscapeKey);
    return () => document.removeEventListener("keydown", handleEscapeKey);
  }, []);

  return (
    <div>
      <div className="memberRegisterContainer forgot_contain">
        <form className="memberRegisterHolder web_login_holder max-w-[600px]" onSubmit={(e) => submitMailToForgot(e)}>
          <div className="prog_det_back forg_back_hold">
            {/* <Link to="/" style={{ textDecoration: "none" }}> */}
            <div className="prog_back_icon" onClick={() => navigate(-1)}></div>
            <div className="prog_det_back_text" onClick={() => navigate(-1)}>
              Back
            </div>
            {/* </Link> */}
          </div>
          <div className="sign_title">Forgot Password</div>
          <div className="info_row_holder">
            <div className="form_title">Email Address</div>
            <div className="relative_holder">
              <input
                type="text"
                tabIndex="1"
                placeholder="john@email.com"
                className="gray_inputs gray_inputs_login w-full"
                onChange={(e) => setEmail(e.currentTarget.value)}
              />
              {errorEmail && <div className="email_error_msg">{errorEmail}</div>}
            </div>
          </div>
          <div className="bottomLoginPadding forg_bottom_hold">
            <div>
              <button className="signNewButton signNew_login forg_submit_button" type="submit">
                SUBMIT
              </button>
              <div className="prog_back_icon forg_submit_icon"></div>
            </div>
          </div>
          <div className="bottomLoginPadding"></div>
        </form>
      </div>
      {successLoad && (
        <div className="dlt_wrapper">
          <div className="dbl_place_on_page">
            <div className="dlt_surround">
              <div className="dlt_title">Password Reset Sent</div>
              <div className="dlt_description">A link to reset your password has been sent to your email address.</div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_scnd dlt_lone_btn" onClick={() => setSuccessLoad(false)}>
                  OK
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;
